/**
 * Module dependencies.
 */

import { cn } from 'app/lib/utils';
import React, { HTMLAttributes } from 'react';

/**
 * Export `Wrapper` component.
 */

export function Wrapper({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('mb-4 flex justify-between rounded-2xl border border-border bg-card p-4', className)}
      {...props}
    />
  );
}

/**
 * Export `Actions` component.
 */

export function Actions({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('flex items-start gap-2', className)} {...props} />;
}

/**
 * Export `FormContent` component.
 */

export function FormContent({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('flex flex-row gap-4', className)} {...props} />;
}
